import '../../stylesheets/accounts/address.css'

document.addEventListener('DOMContentLoaded', function() {
  // 定数
  const editAddressBtn = document.getElementById('editAddressBtn'); // 住所変更ボタン
  const cancelEditBtn = document.getElementById('cancelEditBtn'); // 変更キャンセルボタン
  const addressFormArea = document.getElementById('addressFormArea'); // 住所フォーム
  const motoAddressForms = Array.from(addressFormArea.querySelectorAll('.moto_address')); //元住所表示項目
  const inputForms = Array.from(addressFormArea.querySelectorAll('.address_form')); //住所入力項目
  const zipCodeForm = addressFormArea.querySelector('#customer_zip_code'); // 郵便番号入力欄
  const defaultDisplay = document.getElementById('addressDefaultDisplay'); // 初期表示
  const editableDisplay = document.getElementById('addressEditDisplay'); // 編集表示
  const changePrefectureName = document.getElementById('customer_prefecture_name'); // 都道府県名表示

  // 住所フォーム操作
  const addressFormUtil = {
    // 初期設定
    init: function(){
      [editAddressBtn, cancelEditBtn].forEach((e) =>{ e.addEventListener('click', this.switchFormType)});
      zipCodeForm.addEventListener('change', this.fetchZipAddress);

      if(document.getElementById('errorExplanation') && addressFormArea.dataset.changed === 'true'){
        addressFormUtil.changeFormState(true);  // 編集モード
      }
    },
    // 編集フォーム切り替え
    changeFormState: async function(isEditMode) {
      addressFormUtil.toggleDisplay(isEditMode);
      inputForms.forEach((e) => {
        if (isEditMode) {
          addressFormUtil.activate(e);
          e.classList.remove('d-none');
        } else {
          addressFormUtil.deactivate(e);
          e.classList.add('d-none');
        }
      });
      changePrefectureName.classList.toggle('d-none', !isEditMode);
      motoAddressForms.forEach((e) => {
        e.classList.toggle('d-none', isEditMode);
      });
    },
    // 住所フォーム切り替え
    switchFormType: async function(e){
      const elem = e.currentTarget;
      addressFormUtil.changeFormState(elem == editAddressBtn);

      if (elem == editAddressBtn) {
        const result = await addressFormUtil.searchAddress(zipCodeForm.value);
        addressFormUtil.changeErrorStyle(result);
      }
    },
    // 住所表示切替
    toggleDisplay: function(isEditMode) {
      defaultDisplay.classList.toggle('d-none', isEditMode);
      editableDisplay.classList.toggle('d-none', !isEditMode);
      if (!isEditMode) {
        document.getElementById('ZipCodeNotice').classList.add('d-none');
        document.getElementById('toOutsidePrefectureDisplay').classList.add('d-none');
        addressFormUtil.updateButtonsState(true);
      }
    },
    // 同一郵便番号住所取得
    fetchZipAddress: async function(){
      const result = await addressFormUtil.searchAddress(zipCodeForm.value);
      addressFormUtil.changeErrorStyle(result);
      addressFormUtil.setValues(result, zipCodeForm.value);
    },
    // Ajaxで住所検索
    searchAddress: async function(zipCode = ''){
      try {
        const csrfToken = document.getElementsByName('csrf-token')[0].content;
        const requestBody = { "zip-code": `${zipCode}` };
        const response = await fetch('ajax_change_address_values', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
          body: JSON.stringify(requestBody),
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
      } catch (error) {
        console.error('Error during address search:', error);
        let searchAddressError = document.getElementById('SearchAddressError');
        return { status: 'SearchAddressError', prefecture_name: '', message: searchAddressError.textContent() };
      }
    },
    // 住所フォームに値設定
    setValues: function(result, zipCode = ''){
      const prefectureNameForm = addressFormArea.querySelector('#customer_prefecture_name');
      const changeAddress3Form = addressFormArea.querySelector('#customer_change_address3');

      if (result["status"] == 'Success') {
        zipCodeForm.value = result["zip_code"];
      }
      prefectureNameForm.value = result["prefecture_name"];
      addressFormUtil.resetChangeAddressCodeForm(result);

      changeAddress3Form.value = '';
    },
    // エラー表示変更
    changeErrorStyle: function(result){
      const zipCodeNotice = document.getElementById('ZipCodeNotice');

      zipCodeNotice.classList.add('d-none');
      document.getElementById('toOutsidePrefectureDisplay').classList.add('d-none');

      switch(result["status"]){
        case 'SearchAddressError':
        case 'InvalidZipCode':
          zipCodeNotice.textContent = result["message"];
          zipCodeNotice.classList.remove('d-none');
          addressFormUtil.updateButtonsState(false); // 非活性化
          break;
        case 'InvalidPrefecture':
          document.getElementById('toOutsidePrefectureDisplay').classList.remove('d-none');
          addressFormUtil.updateButtonsState(false); // 非活性化
          break;
        case 'Success':
          addressFormUtil.updateButtonsState(true); // 活性化
          break;
      };
    },
    // 更新ボタン状態変更
    updateButtonsState: function(active){
      Array.from(document.getElementsByClassName('updateMypageBtn')).forEach((elem) =>{
        addressFormUtil.deactivate(elem)
        active ? addressFormUtil.activate(elem) : addressFormUtil.deactivate(elem)
      });
    },
    // 非活性化
    deactivate: function(elem){
      elem.setAttribute("disabled", "");
    },
    activate: function(elem){
      elem.removeAttribute("disabled");
    },
    // 市区町村設定
    resetChangeAddressCodeForm: function(result){
      const changeAddressCodeForm = addressFormArea.querySelector('#customer_change_address_code');
      changeAddressCodeForm.replaceChildren();

      Array.from(result["options"]).forEach((e)=>{
        let option = document.createElement('option');
        option.innerText = e["address"];
        option.value = e["address_code"];

        if(option.value == result["address_code"] && option.innerText == result["address"])
          option.selected = true;

        changeAddressCodeForm.appendChild(option);
      });
    },
    // 県外住所設定時の通知ダイアログ表示
    openNoticeDialog: function(){
      let dialog =
        new bootstrap.Modal(document.getElementById('NoticeDialog'), {
          backdrop: 'static',
          focus: false,
          keyboard: false
        });
      dialog.show();
    }
  };

  addressFormUtil.init();
});